import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import SoftTypography from "components/SoftTypography";
import disableduser from "assets/images/users/disableduser.png";
import statusIcon from "assets/images/university/statusicon.png";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import useStore from "store/hook";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import SchoolIcon from "@mui/icons-material/School";
import EmailIcon from "@mui/icons-material/Email";
import Avatar from "assets/images/Avatar.png";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import ActivateDeactivateUser from "layouts/users/components/ActivateDeactivateuser";
import { useGetuserdetailsQuery } from "store/api/users.api";
import DeletedLabel from "components/DeletedLabel";
import isUserDeleted from "utils/isUserDeleted";

function UserDetails() {
  const [userDetails, setUserDetails] = useState({
    user_name: "",
    user_email: "",
    user_image: "",
    school_name: "",
    isActive: false,
    is_deleted: false,
    reports_count: "",
    status: "",
  });
  const { id } = useParams();
  const location = useLocation();
  const { store, setDialogue } = useStore();
  const logout = useLogout();

  const { data, isLoading, isFetching, error, refetch } = useGetuserdetailsQuery({
    user_id: id,
  });


  useEffect(() => {
    if (data?.status === 1) {
      const user = data?.data || {};
      const { school, reported_count, profile_pictures, name, is_active, email, status } = user;
      const deleted = isUserDeleted(user) || location.state?.isDeleted === true;

      setUserDetails({
        user_name: name || "",
        user_email: email || "",
        user_image: profile_pictures?.[0] || "",
        school_name: school?.name || "",
        city: school?.city || "",
        isActive: is_active,
        is_deleted: deleted,
        reports_count: reported_count || 0,
        status: status,
      });
    } else if (data?.status == 0) {
      toast?.error(Formatmessage(data?.message));
    } else if (data?.status == 10) {
      logout();
    }
  }, [data, id, location.state?.isDeleted]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox
        sx={{ pr: { xs: 1, sm: 2, md: 4 }, pl: { xs: 1, sm: 2, md: 2 } }}
        position="absolute"
        mt={-22}
        width="100%"
      >
        <SoftBox width="100%" display="flex" sx={{ pb: 4 }}>
          {isLoading || isFetching ? (
            <SoftBox
              sx={{
                height: "calc(70vh)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FadeLoader color="#3DC2EB" />
            </SoftBox>
          ) : (
            <SoftBox
              sx={{ py: 2, gap: 2.5, flexDirection: { xs: "column", md: "column" } }}
              borderRadius="md"
              display="flex"
              alignItems="start"
              justifyContent="center"
              width="100%"
            >
              <SoftBox
                sx={{ py: 2, gap: 2.5, flexDirection: { xs: "column", md: "row" } }}
                borderRadius="md"
                display="flex"
                alignItems="start"
                justifyContent="center"
                width="100%"
              >
                <SoftBox
                  borderRadius="md"
                  border="1px solid #D8E0E8"
                  sx={{ backgroundColor: "white.main", width: { xs: "100%", md: "70%" }, p: 1.5 }}
                >
                  <SoftBox
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                    p={1}
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                      alignItems: { xs: "center", sm: "start" },
                    }}
                  >
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      flex={1}
                      gap={1}
                      sx={{
                        ml: { xs: 0, sm: 20 },
                      }}
                    >
                      {/* University Image */}
                      <SoftBox
                        height="140px"
                        width="140px"
                        borderRadius="50%"
                        sx={{
                          backgroundImage: `url(${userDetails?.user_image || Avatar})`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                        }}
                      />

                      {/* University Name + Domain */}
                      <SoftTypography
                        align="center"
                        sx={{ fontSize: 32 }}
                        color="black"
                        fontWeight="normal"
                      >
                        {userDetails?.user_name}
                      </SoftTypography>

                      <SoftBox align="center" display="flex" alignItems="center" gap={1}>
                        <SchoolIcon sx={{ color: "primary.main" }} />
                        <SoftTypography sx={{ fontSize: 16 }} color="black" fontWeight="normal">
                          {userDetails?.city ? userDetails?.city : userDetails?.school_name}
                        </SoftTypography>
                      </SoftBox>

                      <SoftBox align="center" display="flex" alignItems="center" gap={1}>
                        <EmailIcon sx={{ color: "primary.main" }} />
                        <SoftTypography sx={{ fontSize: 16 }} color="black" fontWeight="normal">
                          {userDetails?.user_email}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    <SoftBox display="flex" gap={1}>
                      {userDetails?.is_deleted ? (
                        <DeletedLabel />
                      ) : !userDetails?.isActive ? (
                        <SoftBox
                          onClick={() =>
                            setDialogue({
                              type: "activateDeactivateUser",
                              isOpen: true,
                              action: "activate",
                              userId: id,
                            })
                          }
                          borderRadius="xxl"
                          display="flex"
                          sx={{
                            backgroundColor: "green.light",
                            width: "100%",
                            py: 0.8,
                            gap: 1,
                            px: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <PersonIcon sx={{ height: 20, width: 20, color: "green.main" }} />
                          <SoftTypography
                            fontWeight="normal"
                            sx={{ color: "green.main", fontSize: 13, textTransform: "capitalize" }}
                          >
                            Activate user
                          </SoftTypography>
                        </SoftBox>
                      ) : (
                        <SoftBox
                          onClick={() =>
                            setDialogue({
                              type: "activateDeactivateUser",
                              isOpen: true,
                              action: "deactivate",
                              userId: id,
                            })
                          }
                          borderRadius="xxl"
                          display="flex"
                          sx={{
                            backgroundColor: "red.light",
                            width: "100%",
                            py: 0.8,
                            gap: 1,
                            px: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <PersonOffIcon sx={{ height: 20, width: 20, color: "red.main" }} />
                          <SoftTypography
                            fontWeight="normal"
                            sx={{ color: "red.main", fontSize: 13, textTransform: "capitalize" }}
                          >
                            Deactivate user
                          </SoftTypography>
                        </SoftBox>
                      )}
                    </SoftBox>
                  </SoftBox>
                </SoftBox>

                <SoftBox
                  display="flex"
                  sx={{
                    width: { xs: "100%", md: "30%" },
                    height: "100%",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <SoftBox
                    borderRadius="md"
                    border="1px solid #D8E0E8"
                    py={1}
                    px={2}
                    sx={{ backgroundColor: "white.main", width: "100%", height: "100%" }}
                  >
                    <SoftBox
                      width="100%"
                      display="flex"
                      height="100%"
                      sx={{ alignItems: "center", justifyContent: "space-between" }}
                    >
                      <SoftBox
                        display="flex"
                        height="100%"
                        sx={{
                          alignItems: "center",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <SoftTypography sx={{ fontSize: 16 }} color="black" fontWeight="medium">
                          Reports
                        </SoftTypography>

                        <SoftBox
                          display="flex"
                          alignItems="end"
                          justifyContent="end"
                          sx={{ fontSize: 40 }}
                          color="primary"
                          fontWeight="bold"
                        >
                          {userDetails?.reports_count}
                        </SoftBox>
                      </SoftBox>

                      <SoftBox>
                        <SoftBox
                          height="60px"
                          width="60px"
                          sx={{
                            backgroundImage: `url(${disableduser})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                          }}
                        />
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>

                  <SoftBox
                    borderRadius="md"
                    border="1px solid #D8E0E8"
                    py={1}
                    px={2}
                    sx={{ backgroundColor: "white.main", width: "100%", height: "100%" }}
                  >
                    <SoftBox
                      width="100%"
                      display="flex"
                      height="100%"
                      sx={{ alignItems: "center", justifyContent: "space-between" }}
                    >
                      <SoftBox
                        display="flex"
                        height="100%"
                        pb={2}
                        sx={{
                          alignItems: "start",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <SoftTypography sx={{ fontSize: 16 }} color="black" fontWeight="medium">
                          Status
                        </SoftTypography>

                        {userDetails?.is_deleted ? (
                          <DeletedLabel />
                        ) : (
                          <SoftBox
                            borderRadius="xxl"
                            width="120px"
                            display="flex"
                            sx={{
                              backgroundColor:
                                userDetails?.status == "active"
                                  ? "green.main"
                                  : userDetails?.status == "inactive"
                                    ? "mediumgray.main"
                                    : "error.main",
                              color: "white.main",
                              px: 1,
                              py: 0.5,
                              alignItems: "center",
                              justifyContent: "center",
                              textTransform: "capitalize",
                            }}
                          >
                            {userDetails?.status}
                          </SoftBox>
                        )}
                      </SoftBox>

                      <SoftBox>
                        <SoftBox
                          height="60px"
                          width="60px"
                          sx={{
                            backgroundImage: `url(${statusIcon})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                          }}
                        />
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          )}
        </SoftBox>
      </SoftBox>

      <ActivateDeactivateUser />
      
    </DashboardLayout>
  );
}

export default UserDetails;
